import React, { useContext, useEffect, useRef, useState } from "react";
import AdminLayout from "../../components/admin-layout";
import UserProfile from "../../components/UserProfile/UserProfile";
import { FiLogOut } from "react-icons/fi";
import { GoArrowUpRight } from "react-icons/go";
import SideMessageNotification from "./SideMessageNotification";
import Chart from "chart.js/auto";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ConsultationCard from "../../components/ConsultationCard/ConsultationCard";
import { Link } from "react-router-dom";
import { CgSortAz } from "react-icons/cg";
import ViewRequest from "../../components/ConsultationCard/Viewrequest";
import {
  getDashboardApi,
  getDoctorApibyUserID,
  getNotificationAPI,
  getProfileById,
  getRecentRequest,
  getUserApi,
} from "../../apis";
import LoaderCard from "../../components/ConsultationCard/LoaderCard";
import { AppContext } from "../../appContext";
import ConsultationHistory from "./ConsultationHistory";
import BookingsCard from "./BookingsCard";
import MonthlyCredits from "./MonthlyCredits";
import ViewDetails from "../../components/ConsultationCard/ViewDetails";
import SimpleButton from "../../components/common/buttons/SimpleButton/SimpleButton";
import DashboardHeader from "../../PageComponent/Dashboard/DashboardHeader";
import { FaCalendarAlt, FaVideo } from "react-icons/fa";
import MonthlyExpenditureChart from "../../PageComponent/Dashboard/MonthlyExpenditurechar";
import ConsultatinoHistoryChart from "../../PageComponent/Dashboard/ConsultatinoHistoryChart";
import Placeholder from "../../components/placeholder";
import NoConsultation from "../../lottiefiles/no_consultation.json";

function DashboardOdds() {
  const [viewRequestBlock, setViewRequestBlock] = useState(false);
  const { setIsLoggedIn, logout, setChatCount, chatCount, weavychatcount } =
    useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [recentRequest, setRecentRequest] = useState([]);
  const [rerenderComponent, setRerenderComponent] = useState(false);
  // const [userDetails , setUserDetails] = useState();
  const [reqId, setReqId] = useState();
  const [reload, setReload] = useState(true);
  let consultationBlock;
  const { userDetails } = useContext(AppContext);
  console.log(userDetails);
  const [currentdata, setcurrentdata] = useState(null);
  const [monthlydata, setmonthlydata] = useState([]);
  const [monthlylable, setmonthlylable] = useState([]);
  const [totalcreditused, settotalcreditused] = useState(0);
  const [inpersoncount, setinpersoncount] = useState(0);
  const [virtualcount, setvirtualcount] = useState(0);
  const [consultationhistorylable, setconsultationhistorylable] = useState([]);
  const [consultationhistoryremote, setconsultationhistoryremote] = useState(
    []
  );
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState("");
  const [locationfilter, setlocationfilter] = useState(0);
  useEffect(() => {
    getLocation(); // Trigger on component mount
  }, []); // The empty array ensures this effect runs only once after the initial rendering

  const getLocation = () => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(success, handleError);
  };
  const success = (position) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLocation({ latitude, longitude });
    setError("");
  };
  const handleError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log("User denied the request for Geolocation.");
        setError("Please enable location services and reload the page.");
        handelLocationPromt();
        break;
      case error.POSITION_UNAVAILABLE:
        setError("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        setError("The request to get user location timed out.");
        break;
      default:
        setError("An unknown error occurred.");
        break;
    }
  };
  const [LocationPromt, setLocationPromt] = useState(false);
  function handelLocationPromt() {
    setLocationPromt(!LocationPromt);
  }
  const [consultationhistoryinperson, setconsultationhistoryinperson] =
    useState([]);
  const [consultationhistorysucc, setconsultationhistorysucc] = useState([]);
  const [consultationhistoryremotecount, setconsultationhistoryremotecount] =
    useState(0);
  const [
    consultationhistoryinpersoncount,
    setconsultationhistoryinpersoncount,
  ] = useState(0);
  const [consultationhistorysucccount, setconsultationhistorysucccount] =
    useState(0);
  const [notificationFilter, setNotificationFilter] = useState("");

  const handleFilterChange = (event) => {
    setNotificationFilter(event.target.value);
    // Call getNotification function with the selected filter value
    getNotification(profileData?.DoctorProfile?._id, event.target.value);
  };
  function handelViewCreateRequestBlock(id) {
    setReqId(id);
    setViewRequestBlock(!viewRequestBlock);
  }
  if (loader) {
    consultationBlock = (
      <div className="space-y-3">
        <LoaderCard />
        <LoaderCard />
      </div>
    );
  } else {
    console.log("recentRequest.length", recentRequest.length);
    if (recentRequest && recentRequest.length > 0) {
      const filteredRequests = recentRequest.filter(
        (data) =>
          data?.Consultationstatus === "pending" &&
          userDetails?.DoctorProfile?.specialization?.name ===
            data?.Specalaization?.name
      );

      if (filteredRequests.length > 0) {
        consultationBlock = filteredRequests.map((data, i) => (
          <ConsultationCard
            consultationTitle={data.hospitalName}
            requestId={data.requestId}
            consultationType={data.consType}
            consultationRequest={data.priority}
            requestDescription={data.requestDescription}
            key={i}
            data={data}
            fillBtnTitle="View Details"
            unFillBtnTitle="Delete"
            fillBtnfun={() => {
              handelViewCreateRequestBlock(data?._id);
              setcurrentdata(data);
            }}
          />
        ));
      } else {
        // No matching requests after filter
        consultationBlock = (
          <div className="border bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
            <Placeholder
              title="No requests found."
              animationData={NoConsultation}
              message="No consultation requests were found at this time."
            />
          </div>
        );
      }
    } else {
      // No recent requests at all
      consultationBlock = (
        <div className="border bg-white rounded-lg pt-4 pb-4 flex items-center justify-center mb-28">
          <Placeholder
            title="No requests found."
            animationData={NoConsultation}
            message="No consultation requests were found at this time."
          />
        </div>
      );
    }
  }
  const getAllRecentRequest = async (id, location, lat, long) => {
    try {
      console.log("specal id", id);
      console.log("specal id", lat);
      const res = await getRecentRequest(
        id,
        location,
        lat,
        long,
        userDetails?.DoctorProfile?._id
      );
      if (res.status === 200) {
        // console.log(res.data.consultationAllData);
        const consultationData = res?.data?.consultationAllData.filter(
          (data) => {
            return data?.Consultationstatus != "accepted";
          }
        );
        setRecentRequest(consultationData);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error, "lkop");
    }
  };

  const fetchData = async () => {
    try {
      const res = await getUserApi();
      if (res.status === 200) {
        console.log("profile id", res?.data?.Profile?._id);
        fetchDoctor(res?.data?.Profile?._id);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [profileData, setprofileData] = useState("");
  const fetchDoctor = async (id) => {
    try {
      const res = await getDoctorApibyUserID(id);
      if (res.status === 200) {
        console.log(res.data.Profile);
        setprofileData(res?.data?.Profile);
        Dashboard(res?.data?.Profile?.DoctorProfile?._id);
        getNotification(res?.data?.Profile?.DoctorProfile?._id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [notification, setnotificaiton] = useState(null);
  const getNotification = async (userId, filterval) => {
    try {
      if (!filterval) {
        filterval = "today";
      }
      console.log(userId);
      const res = await getNotificationAPI(userId, filterval);
      if (res.status === 200) {
        console.log(res.data);
        setnotificaiton(res.data.doctorNotification);
      }
    } catch (error) {
      //console.error(error);
    }
  };

  // calculate the sum of counts for a specific category
  const sumCategory = (data, key) =>
    data.reduce(
      (acc, item) => acc + item[key].reduce((x, y) => x + y.count, 0),
      0
    );

  const Dashboard = async (id) => {
    try {
      const res = await getDashboardApi(id);
      if (res.status === 200) {
        console.log(res.data);
        if (res?.data?.consttypecount?.length > 0) {
          setinpersoncount(res?.data?.consttypecount?.[0]?.inperson);
          setvirtualcount(res?.data?.consttypecount?.[0]?.Virtual);
        }
        if (res?.data?.MonthlyEarning?.length > 0) {
          var date_ranges = await res?.data?.MonthlyEarning?.map(
            (item) => item.date_range
          );
          console.log(date_ranges);
          const fullDateRanges = [
            { date_range: "1–7", sortOrder: 1 },
            { date_range: "8–14", sortOrder: 2 },
            { date_range: "15–21", sortOrder: 3 },
            { date_range: "22–28", sortOrder: 4 },
            { date_range: "29–31", sortOrder: 5 },
          ];
          const incomingData = res?.data?.MonthlyEarning;
          console.log("resultincomingdata", incomingData);
          const result = await mergeDateRangeFees(fullDateRanges, incomingData);
          console.log("resultmonthlylable", result);
          setmonthlylable(result);
          var totalDoctorFee = await res?.data?.MonthlyEarning?.map(
            (item) => item.DoctorFee
          );
          console.log(totalDoctorFee);
          setmonthlydata(totalDoctorFee);
          const totalDoctorFeetotal = await res?.data?.MonthlyEarning?.reduce(
            (acc, usage) => acc + usage.DoctorFee,
            0
          );
          settotalcreditused(totalDoctorFeetotal);
        }
        if (res?.data?.completedconstdata?.length > 0) {
          const date_ranges = res.data.completedconstdata.map((item) => {
            if (item.total.length > 0) {
              const totalItem = item.total[0]; // Assuming there's only one item in the total array
              return `${totalItem.monthName}`;
            }
          });
          console.log(date_ranges);
          setconsultationhistorylable(date_ranges);

          const inperson = res.data.completedconstdata.map((item) => {
            if (item.inperson.length > 0) {
              const inpersonItem = item.inperson[0]; // Assuming there's only one item in the inperson array
              return inpersonItem.count;
            }
          });

          console.log(inperson);
          setconsultationhistoryinperson(inperson);

          const virtual = res.data.completedconstdata.map((item) => {
            if (item.Virtual.length > 0) {
              const virtualItem = item.Virtual[0]; // Assuming there's only one item in the Virtual array
              return virtualItem.count;
            }
          });

          console.log(virtual);
          setconsultationhistoryremote(virtual);

          const total = res.data.completedconstdata.map((item) => {
            if (item.total.length > 0) {
              const totalItem = item.total[0]; // Assuming there's only one item in the total array
              return totalItem.count;
            }
          });

          console.log(total);
          setconsultationhistorysucc(total);

          // const inpersonCountconst = res.data.completedconstdata.reduce(
          //   (acc, item) => {
          //     console.log(item.inperson.length);
          //     if (item.inperson.length > 0) {
          //       const inpersonItem = item.inperson[0]; // Assuming there's only one item in the inperson array
          //       return acc + inpersonItem.count;
          //     }
          //     return acc;
          //   },
          //   0
          // );
          
          const inpersonCountconst = sumCategory(res.data.completedconstdata, "inperson");
          console.log(inpersonCountconst);
          setconsultationhistoryinpersoncount(inpersonCountconst);

          // const virtualCountconst = res.data.completedconstdata.reduce(
          //   (acc, item) => {
          //     if (item.Virtual.length > 0) {
          //       const virtualItem = item.Virtual[0]; // Assuming there's only one item in the Virtual array
          //       return acc + virtualItem.count;
          //     }
          //     return acc;
          //   },
          //   0
          // );
          
          const virtualCountconst = sumCategory(res.data.completedconstdata, "Virtual");
          console.log(virtualCountconst);
          setconsultationhistoryremotecount(virtualCountconst);

          // const totalCount = res.data.completedconstdata.reduce((acc, item) => {
          //   if (item.total.length > 0) {
          //     const totalItem = item.total[0]; // Assuming there's only one item in the total array
          //     return acc + totalItem.count;
          //   }
          //   return acc;
          // }, 0);
          const totalCount = sumCategory(res.data.completedconstdata, "total");
          console.log(totalCount);
          setconsultationhistorysucccount(totalCount);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  function normalizeDateRange(str) {
    return str?.replace(/–/g, "-"); // convert en dash to hyphen
  }

  function mergeDateRangeFees(fullDateRanges, monthlyEarningData = []) {
    return fullDateRanges.map((item) => {
      const normalizedItemRange = normalizeDateRange(item.date_range);
      const match = monthlyEarningData.find(
        (d) => normalizeDateRange(d.date_range) === normalizedItemRange
      );
      return {
        ...item,
        doctorFee: match ? match.DoctorFee : 0,
      };
    });
  }

  function onload() {
    // hiddenButtonRef.current.click();
    // location.reload();
    setReload(!reload);
  }
  useEffect(() => {
    fetchData();
    // getUserDetails(localStorage.getItem('userId'));
  }, []);
  useEffect(() => {
    getAllRecentRequest(
      userDetails?.DoctorProfile?.specialization?._id,
      locationfilter,
      location.latitude,
      location.longitude
    );
  }, [reload, userDetails, locationfilter]);
  function handelViewCreateRequestBlock(prop) {
    setReqId(prop);
    setViewRequestBlock(!viewRequestBlock);
  }
  const [viewRequestBlockfull, setViewRequestBlockfull] = useState(null);
  const [openChat, setOpenChat] = useState(false);
  function handelViewCreateRequestBlockfull(prop) {
    if (prop?.type == 'socketmessage') {
      setOpenChat(true);
    } else {
      setOpenChat(false);
    } 
    setReqId(prop?.id);
    setViewRequestBlockfull(!viewRequestBlockfull);
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const consultationHistoryData = [
    {
      name: "Remote",
      value: consultationhistoryremotecount || 0,
      color: "#F1D17A",
    },
    {
      name: "In-person",
      value: consultationhistoryinpersoncount || 0,
      color: "#F588E2",
    },
    {
      name: "Successful",
      value: consultationhistorysucccount || 0,
      color: "#B7AFFF",
    },
  ];
  const fullDateRanges = [
    { date_range: "1–7", sortOrder: 1, totalfee: 0 },
    { date_range: "8–14", sortOrder: 2, totalfee: 0 },
    { date_range: "15–21", sortOrder: 3, totalfee: 0 },
    { date_range: "22–28", sortOrder: 4, totalfee: 0 },
    { date_range: "29–31", sortOrder: 5, totalfee: 0 },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <AdminLayout>
      <DashboardHeader profileData={profileData} />
      <main>
        {/* Dashboard sm screen start */}
        <div className="md:hidden p-4 mb-2 dashboardSmDevices">
          <div className="flex flex-wrap gap-4 justify-center ">
            <BookingsCard
              icon={<FaCalendarAlt size={21} />}
              bookingTitle={"In-person Appointments"}
              bookingCount={inpersoncount}
              bookingPercentage={"4.8%"}
              bookingFromDate={"from last week"}
            />
            <BookingsCard
              icon={<FaVideo size={21} />}
              bookingTitle={"Virtual Appointments"}
              bookingCount={virtualcount}
              bookingPercentage={"10.8%"}
              bookingFromDate={"from last week"}
            />
            {monthlylable.length > 0 ? (
              <MonthlyExpenditureChart data={monthlylable} />
            ) : (
              <MonthlyExpenditureChart data={fullDateRanges} />
            )}
            <ConsultatinoHistoryChart arrdata={consultationHistoryData} />
          </div>
          <section className="mt-14 mb-14">
            <div className="flex justify-between items-center mb-4">
              <p className="text-coalBlack subHeadingText capitalize">
                Consultation Requests
              </p>
              <div className="flex gap-3 items-center flex-row">
                {!error && (
                  <div className="inline-flex items-center cursor-pointer relative group/sort">
                    <CgSortAz className="text-3xl text-accent font-light" />
                    <p className="text-coalBlack baseText !font-medium">
                      Distance
                    </p>
                    <div className="absolute z-50 top-full -left-half bg-white rounded-md shadow-md inline-flex flex-col p-1 gap-1 w-[145px] invisible group-hover/sort:visible">
                      <p
                        className={`${
                          locationfilter === 0
                            ? "text-white bg-accent hover:!bg-accent"
                            : ""
                        } hover:bg-slate-50 baseText px-2 rounded-md py-1 `}
                        onClick={() => {
                          setlocationfilter(0);
                        }}
                      >
                        All
                      </p>
                      <p
                        className={`${
                          locationfilter === 2
                            ? "text-white bg-accent hover:!bg-accent"
                            : ""
                        } hover:bg-slate-50 baseText px-2 rounded-md py-1 `}
                        onClick={() => {
                          setlocationfilter(2);
                        }}
                      >
                        Nearby 2km
                      </p>
                      <p
                        className={`${
                          locationfilter === 5
                            ? "text-white bg-accent hover:!bg-accent"
                            : ""
                        } hover:bg-slate-50 baseText px-2 rounded-md py-1`}
                        onClick={() => {
                          setlocationfilter(5);
                        }}
                      >
                        Upto 5km
                      </p>
                      <p
                        className={`${
                          locationfilter === 10
                            ? "text-white bg-accent hover:!bg-accent"
                            : ""
                        } hover:bg-slate-50 baseText px-2 rounded-md py-1`}
                        onClick={() => {
                          setlocationfilter(10);
                        }}
                      >
                        Upto 10km
                      </p>
                    </div>
                  </div>
                )}
                <Link to={"/requestbroadcast"}>
                  <p className="capitalize smallText text-navLink">see all</p>
                </Link>
              </div>
            </div>

            <div className="space-y-3">{consultationBlock}</div>
          </section>
        </div>
        {/* Dashboard sm screen end */}
        {/* Dashboard large screen start */}
        <div className="mt-6 p-4 hidden md:block">
          <div className="grid grid-cols-12 gap-6  py-4 xl:px-8 xl:pb-0">
            <div className="col-span-12 xl:col-span-8 ">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 3xl:grid-cols-2 place-content-stretch ">
                <BookingsCard
                  icon={<FaCalendarAlt size={21} />}
                  bookingTitle={"In-person Appointments"}
                  bookingCount={inpersoncount}
                  bookingPercentage={"4.8%"}
                  bookingFromDate={"from last week"}
                />
                <BookingsCard
                  icon={<FaVideo size={21} />}
                  bookingTitle={"Virtual Appointments"}
                  bookingCount={virtualcount}
                  bookingPercentage={"10.8%"}
                  bookingFromDate={"from last week"}
                />
                {/* <MonthlyCredits
                  monthlydata={monthlydata}
                  monthlylable={monthlylable}
                  totalCreditCount={totalcreditused}
                /> */}
                {monthlylable.length > 0 ? (
                  <MonthlyExpenditureChart data={monthlylable} />
                ) : (
                  <MonthlyExpenditureChart data={fullDateRanges} />
                )}
                <ConsultatinoHistoryChart arrdata={consultationHistoryData} />
                <div className="mt-8 sm:col-span-2 3xl:col-span-4 py-4 mb-6 lg:mb-0">
                  <div className="flex justify-between items-center mb-6">
                    <p className="capitalize text-coalBlack subHeadingText ">
                      Consultation Requests
                    </p>
                    <div className="flex gap-3 items-center flex-row">
                      {!error && (
                        <div className="inline-flex items-center cursor-pointer relative group/sort">
                          <CgSortAz className="text-3xl text-accent font-light" />
                          <p className="text-coalBlack baseText !font-medium">
                            Distance
                          </p>
                          <div className="absolute z-50 top-full -left-half bg-white rounded-md shadow-md inline-flex flex-col p-1 gap-1 w-[145px] invisible group-hover/sort:visible">
                            <p
                              className={`${
                                locationfilter === 0
                                  ? "text-white bg-accent hover:!bg-accent"
                                  : ""
                              } hover:bg-slate-50 baseText px-2 rounded-md py-1 `}
                              onClick={() => {
                                setlocationfilter(0);
                              }}
                            >
                              All
                            </p>
                            <p
                              className={`${
                                locationfilter === 2
                                  ? "text-white bg-accent hover:!bg-accent"
                                  : ""
                              } hover:bg-slate-50 baseText px-2 rounded-md py-1 `}
                              onClick={() => {
                                setlocationfilter(2);
                              }}
                            >
                              Nearby 2km
                            </p>
                            <p
                              className={`${
                                locationfilter === 5
                                  ? "text-white bg-accent hover:!bg-accent"
                                  : ""
                              } hover:bg-slate-50 baseText px-2 rounded-md py-1`}
                              onClick={() => {
                                setlocationfilter(5);
                              }}
                            >
                              Upto 5km
                            </p>
                            <p
                              className={`${
                                locationfilter === 10
                                  ? "text-white bg-accent hover:!bg-accent"
                                  : ""
                              } hover:bg-slate-50 baseText px-2 rounded-md py-1`}
                              onClick={() => {
                                setlocationfilter(10);
                              }}
                            >
                              Upto 10km
                            </p>
                          </div>
                        </div>
                      )}
                      <Link to={"/requestbroadcast"}>
                        <span className="capitalize text-gray-400 smallText cursor-pointer">
                          see all
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="space-y-3">{consultationBlock}</div>
                </div>
              </div>
            </div>
            <div className="col-span-4  hidden xl:block max-h-[70vh] sticky top-24">
              <div className="flex justify-end mb-4">
                <select
                  className="bg-accent text-white px-4 py-2 rounded-[4px] baseText w-full"
                  value={notificationFilter}
                  onChange={handleFilterChange}
                >
                  <option
                    value="today"
                    className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                  >
                    Today
                  </option>
                  <option
                    value="weekly"
                    className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                  >
                    This Week
                  </option>
                  <option
                    value="monthly"
                    className="text-coalBlack bg-white font-medium text-sm whitespace-nowrap"
                  >
                    This Month
                  </option>
                </select>
              </div>
              <div className="p-4 pb-0 rounded-xl h-full relative bg-white">
                <SideMessageNotification
                  data={notification}
                  profileData={profileData}
                  currentdata={currentdata}
                  setcurrentdata={setcurrentdata}
                  viewFunction={handelViewCreateRequestBlockfull}
                  notificationfun={() => {
                    getNotification(profileData?.DoctorProfile?._id);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard large screen end */}
      </main>

      {/* view request block  */}
      {viewRequestBlock && (
        <ViewRequest
          closeFunction={handelViewCreateRequestBlock}
          reqId={reqId}
          data={currentdata}
          onload={onload}
        />
      )}
      {/* Locaiton Promt pop up  */}
      <div
        className={`fixed top-0 left-0 p-4 w-full h-full bg-black/25  justify-center items-center z-40 ${
          LocationPromt ? "flex" : "hidden"
        }`}
      >
        <div className="bg-white px-4 py-8 rounded-3xl shadow-sm space-y-8 w-full max-w-sm md:px-6 md:py-6 md:space-y-10">
          <p className="text-center text-coalBlack baseText">
            Enable location services to get the distance to your designated
            hospital from your current location.
          </p>
          <div className="grid grid-cols-1">
            <SimpleButton
              title={"Close"}
              buttonType={"primaryUnfilled"}
              customClass={"rounded-xl"}
              onClickEvent={handelLocationPromt}
            />
          </div>
        </div>
      </div>
      {viewRequestBlockfull && (
        <ViewDetails
          closeFunction={handelViewCreateRequestBlockfull}
          currentdata={reqId}
          profileData={profileData}
          navigatedFromNotification={openChat ? true : false}
        />
      )}
    </AdminLayout>
  );
}

export default DashboardOdds;
